// extracted by mini-css-extract-plugin
export var headerCell = "_v-1";
export var loadingSpinnerContainer = "_v-4";
export var rowWrapper = "_v-3";
export var standaloneTable = "_v-5";
export var table = "_v-0";
export var white = "_v-2";